// components/public/ConfirmationDesabonnement.js
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ConfirmationDesabonnement = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [utilisateur, setUtilisateur] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const getEmailFromQuery = () => {
        const urlParams = new URLSearchParams(location.search);
        const emailEncoded = urlParams.get('email');
        return emailEncoded ? decodeURIComponent(emailEncoded) : null;
    };

    const emailCode = getEmailFromQuery();

    useEffect(() => {
        const verifierEmail = async () => {
            try {
                // ⭐ CORRECTION : On envoie l'emailCode ENCODÉ à l'API
                const response = await fetch(
                    `${process.env.REACT_APP_HOTE}/verifier-email-desabonnement/${emailCode}/`
                );

                if (response.ok) {
                    const data = await response.json();
                    setUtilisateur(data);
                }
                else {
                    // Email invalide ou non trouvé
                    navigate('/email-invalide');
                }
            } catch (error) {
                console.error('Erreur:', error);
                navigate('/erreur');
            } finally {
                setLoading(false);
            }
        };

        verifierEmail();
    }, [emailCode, navigate]);

    const handleDesabonnement = async () => {
        setSubmitting(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/desabonner-newsletter/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': getCsrfToken(),
                },
                body: JSON.stringify({
                    email_code: emailCode // On envoie l'email encodé
                })
            });

            if (response.ok) {
                // ⭐⭐ REDIRECTION VERS LE CLIENT MAIL APRÈS SUCCÈS ⭐⭐
                const email = utilisateur?.email || decodeURIComponent(emailCode);
                const mailtoUrl = `mailto:?subject=Confirmation%20d%C3%A9sabonnement&body=Je%20souhaite%20confirmer%20mon%20d%C3%A9sabonnement%20pour%20l%27email%3A%20${encodeURIComponent(email)}`;
                window.location.href = mailtoUrl;

                // Navigation vers la page de confirmation après un délai
                setTimeout(() => {
                    navigate('/desabonnement-confirme');
                }, 2000);

            } else {
                const errorData = await response.json();
                alert(errorData.error || 'Erreur lors du désabonnement');
            }
        } catch (error) {
            console.error('Erreur:', error);
            alert('Erreur réseau lors du désabonnement');
        } finally {
            setSubmitting(false);
        }
    };

    // Fonction pour récupérer le token CSRF
    const getCsrfToken = () => {
        const csrfToken = document.querySelector('[name=csrfmiddlewaretoken]');
        return csrfToken ? csrfToken.value : '';
    };

    // Afficher l'email décodé pour l'utilisateur
    const emailAffiche = utilisateur?.email || decodeURIComponent(emailCode);

    if (loading) {
        return (
            <div style={{ maxWidth: '600px', margin: '50px auto', textAlign: 'center' }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '200px'
                }}>
                    <div className="spinner-border text-success" role="status">
                        <span className="sr-only">Chargement...</span>
                    </div>
                    <p style={{ marginLeft: '15px', color: '#666' }}>Vérification de votre email...</p>
                </div>
            </div>
        );
    }

    return (
        <div style={{
            maxWidth: '600px',
            margin: 'auto',
            textAlign: 'center',
            fontFamily: 'Arial, sans-serif',
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
            <div style={{
                background: 'white',
                padding: '40px',
                borderRadius: '10px',
                // boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                border: '1px solid #e0e0e0'
            }}>
                <div style={{ marginBottom: '30px' }}>
                    <div style={{
                        background: '#fff3cd',
                        padding: '20px',
                        borderRadius: '50%',
                        width: '80px',
                        height: '80px',
                        margin: '0 auto 20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '2px solid #ffc107'
                    }}>
                        <span style={{ fontSize: '30px' }}>📧</span>
                    </div>
                    <h2 style={{
                        color: '#856404',
                        marginBottom: '15px',
                        fontSize: '24px',
                        fontWeight: '600'
                    }}>
                        Confirmer le désabonnement
                    </h2>
                    <p style={{
                        color: '#666',
                        lineHeight: '1.6',
                        fontSize: '16px',
                        marginBottom: '10px'
                    }}>
                        Êtes-vous sûr de vouloir vous désabonner des newsletters de <strong>INOVACT SARL</strong> ?
                    </p>

                    {/* ⭐ CORRECTION : Affichage de l'email décodé */}
                    <div style={{
                        background: '#f8f9fa',
                        padding: '15px',
                        borderRadius: '8px',
                        margin: '15px 0'
                    }}>
                        <p style={{
                            color: '#495057',
                            fontSize: '14px',
                            margin: '0',
                            fontWeight: '500'
                        }}>
                            Email : <span style={{ color: '#2c5aa0' }}>{emailAffiche}</span>
                        </p>
                        {utilisateur?.nom && (
                            <p style={{
                                color: '#6c757d',
                                fontSize: '13px',
                                margin: '5px 0 0 0',
                                fontStyle: 'italic'
                            }}>
                                {utilisateur.prenoms} {utilisateur.nom}
                            </p>
                        )}
                    </div>

                    <p style={{
                        color: '#6c757d',
                        fontSize: '14px',
                        marginTop: '15px'
                    }}>
                        ⚠️ Vous ne recevrez plus nos actualités, conseils et offres promotionnelles.
                    </p>
                </div>

                <div style={{ marginBottom: '25px' }}>
                    <button
                        onClick={handleDesabonnement}
                        disabled={submitting}
                        style={{
                            background: submitting ? '#6c757d' : '#dc3545',
                            color: 'white',
                            padding: '12px 30px',
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '16px',
                            fontWeight: '600',
                            cursor: submitting ? 'not-allowed' : 'pointer',
                            transition: 'all 0.3s ease',
                            marginBottom: '15px',
                            width: '100%',
                            maxWidth: '280px',
                            boxShadow: submitting ? 'none' : '0 2px 4px rgba(220, 53, 69, 0.3)'
                        }}
                        onMouseOver={(e) => {
                            if (!submitting) {
                                e.target.style.background = '#c82333';
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 4px 8px rgba(220, 53, 69, 0.4)';
                            }
                        }}
                        onMouseOut={(e) => {
                            if (!submitting) {
                                e.target.style.background = '#dc3545';
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 2px 4px rgba(220, 53, 69, 0.3)';
                            }
                        }}
                    >
                        {submitting ? (
                            <>
                                <span
                                    className="spinner-border spinner-border-sm"
                                    style={{ marginRight: '8px' }}
                                ></span>
                                Désabonnement en cours...
                            </>
                        ) : (
                            '✅ Se désabonner'
                        )}
                    </button>
                </div>

            </div>
            <div
              className="ibox-footer full-w mt-2 d-flex align-items-center justify-content-between pl-3 pr-3"
              style={{
                textAlign: 'center',
                width: '100%',
                maxWidth: '1140px', // S'alignera avec la largeur du loginColumns
                borderTop: '1px solid #e7eaec', // Ligne de séparation optionnelle
                backgroundColor: '#f9f9f9', // Fond léger optionnel
              }}
            >

              {/* Copyright */}
              <small>© {new Date().getFullYear()} <strong>Inovact</strong>. Tous droits réservés.</small>

              <div className="d-flex align-items-center justify-content-between">
                <small className="me-3 text-muted mr-2">Nous suivre</small>
                <div className="d-flex align-items-center gap-3">
                  <a href="https://www.facebook.com/inovact/" className="text-decoration-none social-icon d-flex align-items-center justify-content-center mr-2"
                    style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      backgroundColor: '#4c4d4e10',
                      border: '1px solid #4c4d4e10',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#6c757d';
                      e.currentTarget.style.borderColor = '#6c757d';
                      e.currentTarget.querySelector('i').style.color = 'white';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#4c4d4e10';
                      e.currentTarget.style.borderColor = '#4c4d4e10';
                      e.currentTarget.querySelector('i').style.color = '#6c757d';
                    }}
                    title="Facebook">
                    <i className="fa fa-facebook-f" style={{ fontSize: '12px', color: '#6c757d', transition: 'color 0.3s ease' }}></i>
                  </a>
                  <a href="https://x.com/Inovact_Sarl" className="text-decoration-none social-icon d-flex align-items-center justify-content-center mr-2"
                    style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      backgroundColor: '#4c4d4e10',
                      border: '1px solid #4c4d4e10',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#6c757d';
                      e.currentTarget.style.borderColor = '#6c757d';
                      e.currentTarget.querySelector('i').style.color = 'white';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#4c4d4e10';
                      e.currentTarget.style.borderColor = '#4c4d4e10';
                      e.currentTarget.querySelector('i').style.color = '#6c757d';
                    }}
                    title="Twitter">
                    <i className="fa fa-twitter" style={{ fontSize: '12px', color: '#6c757d', transition: 'color 0.3s ease' }}></i>
                  </a>
                  <a href="https://www.linkedin.com/company/inovact" className="text-decoration-none social-icon d-flex align-items-center justify-content-center mr-2"
                    style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      backgroundColor: '#4c4d4e10',
                      border: '1px solid #4c4d4e10',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#6c757d';
                      e.currentTarget.style.borderColor = '#6c757d';
                      e.currentTarget.querySelector('i').style.color = 'white';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#4c4d4e10';
                      e.currentTarget.style.borderColor = '#4c4d4e10';
                      e.currentTarget.querySelector('i').style.color = '#6c757d';
                    }}
                    title="LinkedIn">
                    <i className="fa fa-linkedin" style={{ fontSize: '12px', color: '#6c757d', transition: 'color 0.3s ease' }}></i>
                  </a>
                </div>
              </div>
            </div>

            

            {/* Token CSRF caché pour Django */}
            <input type="hidden" name="csrfmiddlewaretoken" value="" />
        </div>
    );
};

export default ConfirmationDesabonnement;